import style from './block.module.scss';
import { CategoryList } from './CategoryList';
import { NavMenu } from './NavMenu';
import { BlockWrapper, defineBlock, smartProps } from '@smartfire/js-block-engine';
import { EditableText, EditableImg } from '@smartfire/components';
import { Socials } from './Socials';

function Footer({ custom_settings, categories, navMenu, categoriesAlias }) {
    return (
        <BlockWrapper.Without>
            <div className={style.line} />
            <div className={style.footerContainer}>
                <div className={style.rowText}>
                    <EditableText
                        smartProp={'text'}
                        placeholder={'Entrez ici le text du footer'}
                        allowedFormats={['core/bold', 'core/italic']}
                        className={style.editableText}
                    />
                    <div className={style.menus}>
                        <CategoryList categories={categories} categoriesAlias={categoriesAlias} />
                        <NavMenu menu={navMenu} />
                    </div>
                </div>
                <div className={style.rowLogos}>
                    <EditableImg smartProp={'logo'} className={style.logo} />
                    <Socials socials={custom_settings} />
                </div>
            </div>
        </BlockWrapper.Without>
    );
}

export default defineBlock({
    Block: Footer,
    smartProps: {
        text: smartProps.string.withDefault(''),
        logo: smartProps.image,
    },
    setup: {
        title: 'Footer',
        icon: 'table-row-after',
    },
});
